import { DomPortalOutlet } from '@angular/cdk/portal';
import { Component, Input } from '@angular/core';
import { FileUpload } from '../../../models/IFileUpload';

@Component({
  selector: 'ff-single-image-loader',
  templateUrl: './single-image-loader.component.html',
  styleUrls: ['./single-image-loader.component.scss']
})
export class SingleImageLoaderComponent {

  constructor() { }

  private bodyPortalOutlet: DomPortalOutlet
  
  /**
   * Callback that will receive the selected file list
   * and execute the function 
   * * @internal
  */
  @Input() onSave: (file: FileUpload) => void;

  //Flag for applying image loaded to all rows
  checked: boolean = false;

  //Method to close the modal
  clear   = () => { this.bodyPortalOutlet.detach(); }

  //Array that will contain selected files
  file: File = null;

  /**
   * on file drop handler
   */
   onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

   /**
   * on save button click
   */
  save() {   
    if (this.onSave) { 
      const fileUpload : FileUpload = new FileUpload;
      fileUpload.file = this.file;
      fileUpload.applyToAll = this.checked;
      this.onSave(fileUpload); 
    }
    this.clear();
  }
  

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
   async prepareFilesList(file: any) {

      if(file[0] !== undefined){      
        //File extension validation
        let idxDot = file[0].type.lastIndexOf("/") + 1,
        extFile = file[0].type.substr(idxDot, file[0].type.length).toLowerCase();

        if (extFile=="jpg" || extFile=="jpeg" || extFile=="png" || extFile=="gif"){
          
          file[0].src = await this.getSource(file[0]).then((value) => {
            return value as string;
          });
          
          this.file = file[0];
        }
      }
  }

  //Method to return the url source of the file
  getSource(file: File) {

    return new Promise((res, rej) => {
      // create file reader
      let reader = new FileReader();

      // read file
      reader.readAsDataURL(file);
      
      // register event listeners
      reader.addEventListener("loadend", e => res(reader.result));
      reader.addEventListener("error", rej);
      

   });

 }
}

